import React from 'react';
import PropTypes from 'prop-types';

/**
 * Wrapper element for template content
 */
const ContentWrapper = ({ children, unwrap = false }) => (
    <div className="content-wrapper">
        {unwrap ?
            (<div className="unwrap">{children}</div>)
            :
            (children)
        }
    </div>
)

ContentWrapper.propTypes = {
    children: PropTypes.node,
    /** add element with 'unwrap' class to expand content area */
    unwrap: PropTypes.bool
}

export default ContentWrapper;
